import type { Notification, NotificationPreference } from './types.js';

const API_BASE = '/api/notifications';

async function request<T>(path: string, options: RequestInit = {}): Promise<T> {
  const response = await fetch(`${API_BASE}${path}`, {
    ...options,
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...options.headers },
  });
  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Request failed' }));
    throw new Error(error.error || 'Request failed');
  }
  return response.json();
}

export const notificationApi = {
  getNotifications: () => request<Notification[]>('/'),
  getUnreadCount: () => request<{ count: number }>('/unread-count'),
  markRead: (id: number) => request(`/${id}/read`, { method: 'PATCH' }),
  markAllRead: () => request('/mark-all-read', { method: 'POST' }),
  getPreferences: () => request<NotificationPreference[]>('/preferences'),
  updatePreference: (notification_type: string, enabled: boolean, sub_option?: string) =>
    request('/preferences', { method: 'PUT', body: JSON.stringify({ notification_type, enabled, sub_option }) }),
};
